import { CSSProperties } from 'react'
import * as S from './styles';

interface InputMensageProps {
    form: boolean | (null | undefined),
    label: string | (null | undefined),
    type: "badInput" | "patternMismatch" | "rangeOverflow" | "rangeUnderflow" | "stepMismatch" | "tooLong" | "tooShort" | "typeMismatch" | "valid" | "valueMissing" | undefined
    style?: CSSProperties | undefined;
}

export function InputMensage(props: InputMensageProps) {

    return (
        props.label &&
        (
            props.form ?
                <S.InputMessage style={props.style} className="FormMessage" match={props.type}>
                    {props.label}
                </S.InputMessage>
                :
                <label style={props.style} >{props.label}</label>
        )
    )
}
